import { Component, OnInit, OnDestroy, Output, EventEmitter } from '@angular/core';
import { Router } from "@angular/router";

import { Subscription } from 'rxjs';

import { ProjectsService } from '@app/services/app/projects.service';
import { AppService } from 'app/services/app/app.service';
import { VersionsService } from '@app/services/app/versions.service';


import * as Objects from '@core/objects';
import { VersionShareItem } from '@core/models/version-share.model';
import { VersionSharesService } from '@core/services/version-shares/version-shares.service';
import { NotificationsContextEnum } from '@core/store/models/notifications.enum';

import { ThreeDotsMenuItem } from '@core/components/helpers/navigation/three-dots-menu/three-dots-menu-item';
import { VersionListItemMenuClick } from '@core/components/versions/list/version-list-item-menu-click';
import { NotificationsService } from '@core/services/notifications/notifications.service';

@Component({
    selector: 'project-details-info-origin-version',
    templateUrl: './origin-version.component.html',
    styleUrls: ['./origin-version.component.scss']
})
export class ProjectDetailsInfoOriginVersionComponent implements OnInit, OnDestroy {
    protected readonly ACCESS_REQUEST_FEEDBACK = 'share_feedback';

    public readonly STATUS_LOADING = 0;
    public readonly STATUS_DONE = 1;
    public readonly STATUS_NOT_ALLOWED = 2;

    public menu: Array<ThreeDotsMenuItem> = [
        {
            title: "See Artwork Details",
            key: "details",
            icon: "see-details",
            order: 1
        },
        {
            title: "Download All Files",
            key: "download-all",
            icon: "download",
            order: 2
        }
    ];

    public version: Objects.Version = null;
    public project: Objects.Request = null;
    public feedbackPluginAccess: boolean = false;
    public feedbacks: Array<VersionShareItem> = null;
    public status: number = this.STATUS_LOADING;

    protected subscriptor: Subscription;
    protected appSubscriptor: Subscription;
    protected feedbacksSubscriptor: Subscription;

	constructor(private versionSharesSrv: VersionSharesService, private router: Router,
        private notifSrv: NotificationsService, private projectsSrv: ProjectsService,private app: AppService,private versionsSrv: VersionsService){}

	ngOnInit(){

        // get plugins access
        this.appSubscriptor = this.app.getSession().subscribe( (session: any) => {
            this.feedbackPluginAccess = session.options.plugins.some((pa) => pa == this.ACCESS_REQUEST_FEEDBACK);
            this.initView();
        });

        this.subscriptor = this.projectsSrv.selectOriginVersion().subscribe((version: Objects.Version ) => {
            if (version != null){
                this.version = version;
                this.initView();
                // this.status = this.STATUS_DONE;
            }
        });


	}

    ngOnDestroy() {
        this.subscriptor.unsubscribe();
        this.appSubscriptor.unsubscribe();
        if(this.feedbacksSubscriptor)
            this.feedbacksSubscriptor.unsubscribe();
    }

    initView(){
        if(this.version != null){
            this.status = this.STATUS_DONE;
            this.initFeedbacks([this.version]);
        }
    }

    public getFeedbacks(version: Objects.Version){
        return this.feedbacks != null ? this.feedbacks.filter((f: VersionShareItem) => f.version.id == version.id) : null;
    }

    onMenuClick(menu: VersionListItemMenuClick) {
        console.debug(" menu original click",menu.key);
        switch(menu.key) {
            case "download-all":
                // start notification to download compressed version files in zip
                this.notifSrv.addNotification(NotificationsContextEnum.EVENT_FILES_COMPRESSION_START, {id: menu.version.id, details: { url: "/versions/"+menu.version.id }});
                break;
            case "details":
                // navigate to Artwork Details
                this.router.navigate([ "/versions/"+this.version.id]);
                break;
        }
    }

    onFileClick(file: Objects.File){
        if (file != null ){
            // set this url to preview artwork FILE
            this.router.navigate(["/versions/"+this.version.id + "/files/"+file.id]);
        }
    }

    // feedback still come one by one for each version!!
    protected initFeedbacks(versions: Array<Objects.Version>) {
        if(!this.feedbackPluginAccess) {
            this.feedbacks = [];
            return;
        }

        // @deprecated oct-2026: legacy share feedback bubbles url call, replaced by VersionSharesService.getVersionShareItems$
        // this.feedbacksSubscriptor = this.versionsSrv.getFeedbacks$(versions).subscribe((feedbacks: Array<VersionShareItem>) => {
        this.feedbacksSubscriptor = this.versionSharesSrv.getVersionShareItems$(versions).subscribe((feedbacks: Array<VersionShareItem>) => {
                this.feedbacks = feedbacks;
                this.status = this.STATUS_DONE;
        });
    }

}
